<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <div class="card-body pt-9 pb-0">
        <!--begin::Details-->
        <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
          <!--begin: Pic-->
          <div class="me-7 mb-4">
            <div
              class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative"
            >
              <img
                :src="
                  user.avatarUrl === null
                    ? 'media/avatars/blank.png'
                    : user.avatarUrl
                "
                alt="image"
              />
              <div
                class="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"
              ></div>
            </div>
          </div>
          <!--end::Pic-->

          <!--begin::Info-->
          <div class="flex-grow-1">
            <!--begin::Title-->
            <div
              class="d-flex justify-content-between align-items-start flex-wrap mb-2"
            >
              <!--begin::User-->
              <div class="d-flex flex-column">
                <!--begin::Name-->
                <div class="d-flex align-items-center mb-2">
                  <a
                    class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                    >{{ user.firstName }} {{ user.lastName }}</a
                  >
                  <a>
                    <span
                      :class="`${
                        user.active === true
                          ? 'svg-icon svg-icon-1 svg-icon-primary'
                          : ''
                      }`"
                      :title="
                        user.active === true
                          ? translate('Active')
                          : translate('Passive')
                      "
                    >
                      <inline-svg
                        :src="`${
                          user.active === true
                            ? 'media/icons/duotune/general/gen026.svg'
                            : 'media/icons/duotune/general/not-active.svg'
                        }`"
                      />
                    </span>
                  </a>

                  <a
                    @click="changeActive(user.active)"
                    :class="`btn btn-sm fw-bolder ms-2 fs-8 py-1 px-3 ${
                      user.active === false
                        ? 'btn-light-primary'
                        : 'btn-light-danger'
                    }`"
                    >{{
                      user.active === false
                        ? translate("Activate")
                        : translate("Deactivate")
                    }}</a
                  >
                </div>
                <!--end::Name-->

                <!--begin::Info-->
                <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                  <a
                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  >
                    {{ user.countryName }}
                  </a>
                  <a
                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg
                        src="media/icons/duotune/general/gen018.svg"
                      />
                    </span>
                    {{ user.cityName }}, {{ user.districtName }}
                  </a>
                  <a
                    :href="`mailto:${user.email}`"
                    class="d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                  >
                    <span class="svg-icon svg-icon-4 me-1">
                      <inline-svg
                        src="media/icons/duotune/communication/com011.svg"
                      />
                    </span>
                    {{ user.email }}
                  </a>
                </div>
                <!--end::Info-->
              </div>
              <!--end::User-->

              <div
                class="btn btn-icon btn-sm btn-active-light border"
                :title="translate('question_component_button_backto_list')"
                @click="router.push({ name: 'admin-users' })"
              >
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/arrows/arr077.svg" />
                </span>
              </div>

              <!--              
              <div class="d-flex my-4">
                <a
                  class="btn btn-sm btn-light-danger me-3"
                  @click="deleteUser($event)"
                  >{{ translate("Delete") }}</a
                >

               
              </div>
               -->
            </div>

            <!--end::Stats-->
          </div>
          <!--end::Info-->
        </div>
        <!--end::Details-->

        <!--begin::Navs-->
        <div class="d-flex overflow-auto h-55px">
          <ul
            class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 flex-nowrap"
          >
            <!--begin::Nav item-->
            <li v-for="(item, index) in tabs" :key="index" class="nav-item">
              <a
                :class="`nav-link me-6 ${
                  tab === item.name ? 'active langue-tabs-bold' : ''
                } `"
                style="cursor: pointer"
                @click="changeTab(item)"
              >
                {{ translate(item.name) }}
              </a>
            </li>
            <!--end::Nav item-->
          </ul>
        </div>
        <!--begin::Navs-->
      </div>
    </div>
    <transition name="component-fade" mode="out-in">
      <keep-alive>
        <component :is="showComponent"> </component>
      </keep-alive>
    </transition>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { computed, reactive, ref, provide, shallowRef, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import UsersModule from "@/store/modules/Users/UsersModule";

const router = useRouter();
const route = useRoute();
const userId = ref(route.params.id);

//Store Tanımlaması
const store = useStore();
const block = ref(true);

const tabs = ref([
  { name: "Detail" },
  { name: "Projects" },
  { name: "UserTimeLine" },
  { name: "UserAuditLine" },
]);
const tab = ref("Detail");
const showComponent = shallowRef();

const changeTab = (item) => {
  tab.value = item.name;

  if (item.name !== "") {
    import("@/components/Admin/Users/Detail/" + item.name + ".vue").then(
      (value) => {
        showComponent.value = value.default;
      }
    );
  }
};

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

// User İşlemleri
const user = reactive({
  id: 0,
  firstName: null,
  lastName: null,
  email: null,
  password: null,
  phone: null,
  countryId: 0,
  countryName: null,
  cityId: 0,
  cityName: null,
  districtId: 0,
  districtName: null,
  streetAddress: null,
  groups: null,
  defaultLanguageId: 0,
  defaultLanguageName: null,
  avatarUrl: null,
  active: true,
  timezoneId: null,
  isAuditor: true,
});

const getUser = () => {
  store
    .dispatch("UsersModule/GET_USER", userId.value)
    .then((response) => {
      let array = [];
      user.id = response.Id;
      user.firstName = response.Firstname;
      user.lastName = response.Lastname;
      user.email = response.Email;
      user.active = response.Active;
      user.isAuditor = response.IsAuditor;
      user.districtId = response.DistrictId;
      user.districtName = response.DistrictName;
      user.countryId = response.CountryId;
      user.countryName = response.CountryName;
      user.cityId = response.CityId;
      user.cityName = response.CityName;
      user.streetAddress = response.StreetAddress;
      response.Groups.forEach((x) => array.push(String(x)));
      user.groups = array;
      user.phone = response.Phone;
      user.avatarUrl = response.AvatarUrl === "" ? null : response.AvatarUrl;
      user.defaultLanguageId = response.DefaultLanguageId;
      user.defaultLanguageName = response.DefaultLanguageName;
      user.timezoneId = response.TimezoneId;
      setCurrentPageBreadcrumbs(`${user.firstName + " " + user.lastName}`, [
        translate("Users"),
      ]);
    })
    .finally(() => (block.value = false));
};

watch(locale, () => {
  setCurrentPageBreadcrumbs(`${user.firstName + " " + user.lastName}`, [
    translate("Users"),
  ]);
});

const changeActive = () => {
  UsersModule.actions
    .CHANGE_ACTIVE(null, { userId: user.id, active: !user.active })
    .then((response) => {
      if (response) {
        user.active = !user.active;
      }
    });
};

const userUpdated = () => {
  getUser();
};

// const deleteUser = (event) => {
//   confirm.require({
//     target: event.currentTarget,
//     message: "Are you sure you want to proceed?",
//     icon: "bi bi-exclamation-lg",
//     acceptLabel: "Evet",
//     rejectLabel: "Hayır",
//     acceptClass: "btn btn-sm btn-light-success",
//     rejectClass: "btn btn-sm btn-light-danger",
//     accept: () => {
//       console.log("Delete User");
//     },
//     reject: () => {
//       return;
//     },
//   });
// };

changeTab({ name: "Detail" });
provide("user", user);
provide("userUpdated", userUpdated);
getUser();
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
</style>
